/**
 * Scroll Reveal — IntersectionObserver-based fade-in animation
 * Elements with class .reveal get .visible added when they enter the viewport.
 */
export const scrollReveal = {
    init() {
        const elements = document.querySelectorAll('main section');

        if ( ! elements.length || ! ('IntersectionObserver' in window) ) {
            return;
        }

        elements.forEach( el => {
            el.classList.add( 'reveal' );

            new IntersectionObserver( ( [ entry ] ) => {
                if ( entry.isIntersecting ) {
                    entry.target.classList.add( 'visible' );
                }
            }, { threshold: 0.1 } ).observe( el );
        });
    },
};
